import React from "react";
import Binary from "./components/binary";
import Segmented from "./components/segmented";
import Ternary from "./components/ternary";
import "../styles/index";

function Edit(props: {
  cy?: string;
  key?: string;
  description?: string;
  id?: string;
  disabled?: boolean;
  value: boolean | null;
  label: any;
  binary?: boolean;
  segmented?: boolean;
  onChange?: (value: boolean | null) => void;
}) {
  if (props.segmented) {
    return <Segmented {...props} />;
  }

  return props.binary ? <Binary {...props} /> : <Ternary {...props} />;
}

Edit.displayName = "BooleanRowEdit";

export default Edit;
